import React from 'react';

const EngineerFooter = () => {
    const currentYear = new Date().getFullYear();
    
    return (
        <footer className="bg-[#f6f3ee] border-t border-gray-200 py-6 px-8 mt-auto">
            <div className="max-w-[1600px] mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
                <div className="text-gray-500 text-sm font-medium">
                    © Copyright {currentYear} <span className="text-blue-600 font-bold">Zilla Parishad Sangli</span>. 
                    All Rights Reserved.
                </div>
                <div className="flex items-center gap-2">
                    <span className="text-gray-400 text-[12px] font-bold uppercase tracking-wider">
                        Design & Developed by
                    </span>
                    <span className="bg-blue-50 text-blue-600 px-3 py-1 rounded-full text-[11px] font-black uppercase tracking-widest border border-blue-100">
                        Zilla Parishad
                    </span>
                </div>
            </div>
        </footer>
    );
};

export default EngineerFooter;
